// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3.9996 2H10.9996V7.92353L11.3191 10H21.9996V22H16V16H14V22H1.83398L3.9996 7.92353V2ZM8.9996 8.07647V4H5.9996V8.07647L4.16521 20H7.9996V10H9.29552L8.9996 8.07647Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chimney-2-filled')
export default class Chimney2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chimney-2-filled',
    }
  }
}
